import React from "react";
import { Box, Typography, Paper, Grid, Divider } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton"; // Correct import path
import useDashboardSectionStyles from "./useDashboardSectionStyles"; // Reuse styles if applicable

function DashboardStatsBar({ stats, loading }) {
  const classes = useDashboardSectionStyles(); // Or create specific styles

  const StatItem = ({ value, label, loading }) => (
    <Grid item xs>
      <Box display="flex" alignItems="center">
        <Typography variant="h6" className={classes.statNumber}>
          {loading ? <Skeleton width={40} /> : value}
        </Typography>
        <Typography
          variant="body2"
          className={classes.statLabel}
          style={{ marginLeft: "8px" }}
        >
          {loading ? <Skeleton width={80} /> : label}
        </Typography>
      </Box>
    </Grid>
  );

  // Render skeleton if stats are null/undefined and loading is true
  const showSkeleton = loading && !stats;

  return (
    <Box mt={3} mb={3}>
      <Paper className={classes.simplifiedStatsBar} elevation={1}>
        <Grid container spacing={2} alignItems="center">
          <StatItem
            value={showSkeleton ? 0 : stats?.totalApplications ?? 0}
            label="Applications"
            loading={showSkeleton}
          />
          <Divider orientation="vertical" flexItem />
          <StatItem
            value={showSkeleton ? 0 : stats?.interviewsCount ?? 0}
            label="Interviews"
            loading={showSkeleton}
          />
          <Divider orientation="vertical" flexItem />
          <StatItem
            value={showSkeleton ? 0 : stats?.offersCount ?? 0}
            label="Offers"
            loading={showSkeleton}
          />
        </Grid>
      </Paper>
    </Box>
  );
}

export default DashboardStatsBar;
